module.exports = __webpack_public_path__ + "static/national-president-9b5368c90309eeecc3f48c1acc396c1d.png";